<template>
    <nav class="Navbar">

        <div class="logo_container">
            <img @click="goToHome" src="@/assets/images/rocketprint-logo.png" alt="Rocket Print logo">
        </div>

        <!-- MobileMenu -->
        <MobileMenu />

        <!-- Full width Menu -->
        <Menu />

    </nav>
</template>

<script>
import MobileMenu from '@/components/MobileMenu/MobileMenu'
import Menu from '@/components/Menu'

export default {
    name: 'Navbar',
    components: {
        MobileMenu,
        Menu
	},
	methods: {
		goToHome() {
			this.$router.push('/')
		}
	}
}
</script>

<style lang="scss" scoped>

.Navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 20;
    background: white;
    height: 80px;
    padding: 0 15px;
    border-bottom: 1px solid whitesmoke;
    // @include box-shadow(0px 10px 20px -15px rgba(0,0,0,0.24));
	@include box-shadow(0px 4px 5px -6px rgba(0,0,0,0.75));
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
        width: 180px;
		cursor: pointer;
    }
}

@media screen and (min-width: 1024px) {
    .Navbar {
        padding: 0 30px;
    }
}

</style>
